import { useState } from 'react'
import { useEffect } from 'react'
import useAuth from '../../../hooks/useAuth'
import NavItem from '../../NavItem/NavItem'

const BurgerMenu = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const { logout, isAdmin } = useAuth()

    const toggleMenu = () => {
        setMenuOpen(!menuOpen)
    }

    useEffect(() => {
        const menuHeader = document.getElementById('mobile-header')
        const profileButton = document.getElementById('profileBtn')
        const closeMenu = () => {
            setMenuOpen(false)
        }
        if (!menuOpen) {
            if (isAdmin()) {
                menuHeader.classList.remove('fixed')
                menuHeader.classList.add('rounded-b-[30px]')
            } else {
                menuHeader.classList.remove('fixed', 'bg-white')
            }
        } else {
            if (isAdmin()) {
                menuHeader.classList.add('fixed')
                menuHeader.classList.remove('rounded-b-[30px]')
            } else {
                menuHeader.classList.add('fixed', 'bg-white')
                menuHeader.classList.remove('bg-[#f0f3f4]')
                if (profileButton) {
                    profileButton.addEventListener('click', closeMenu)
                }
            }
        }
        return () => {
            if (profileButton) {
                profileButton.removeEventListener('click', closeMenu)
            }
        }
    }, [menuOpen])

    const adminClasses = 'font-bold text-2xl text-white'

    return (
        <>
            <button onClick={toggleMenu}>
                <span className="font-bold text-5xl" aria-hidden="true">
                    {menuOpen ? (
                        isAdmin() ? (
                            <div className="-space-y-1">
                                <div className="w-8 h-1 bg-white rotate-45"></div>
                                <div className="w-8 h-1 bg-white -rotate-45"></div>
                            </div>
                        ) : (
                            <div className="-space-y-1">
                                <div className="w-8 h-1 bg-accent rotate-45"></div>
                                <div className="w-8 h-1 bg-accent -rotate-45"></div>
                            </div>
                        )
                    ) : isAdmin() ? (
                        <div className="space-y-2">
                            <div className="w-8 h-1 bg-white"></div>
                            <div className="w-8 h-1 bg-white"></div>
                        </div>
                    ) : (
                        <div className="space-y-2">
                            <div className="w-8 h-1 bg-accent"></div>
                            <div className="w-8 h-1 bg-accent"></div>
                        </div>
                    )}
                </span>
            </button>

            {menuOpen ? (
                <>
                    <div
                        className={`fixed h-[calc(100%-93px)] overflow-y-auto w-full z-10 left-0 top-[93px] ${
                            isAdmin() ? 'bg-primary' : 'bg-white'
                        } h-full`}
                    >
                        <div className="flex flex-col items-center">
                            <ul className="flex gap-8 flex-col items-center justify-start py-10">
                                {isAdmin() ? (
                                    <>
                                        <NavItem
                                            classes="font-bold text-2xl text-white"
                                            path="/admin/payment"
                                            text="Πληρωμές Οφειλών"
                                            closeFunction={toggleMenu}
                                        />
                                        <NavItem
                                            classes="font-bold text-2xl text-white"
                                            path="/admin/balance-request"
                                            text="Αιτήσεις Υπολοίπου"
                                            closeFunction={toggleMenu}
                                        />

                                        <NavItem
                                            classes={adminClasses}
                                            path="/admin/kok"
                                            text="Κλήσεις Κ.Ο.Κ."
                                            closeFunction={toggleMenu}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <NavItem
                                            classes="font-bold text-2xl text-center rounded-md py-2 px-4"
                                            path="/payment"
                                            text="Άμεση Πληρωμή"
                                            closeFunction={toggleMenu}
                                        />
                                        <NavItem
                                            classes="font-bold text-2xl text-center rounded-md py-2 px-4"
                                            path="/balance-requests"
                                            text="Αίτηση Υπολοίπου και ιστορικό αιτήσεων"
                                            closeFunction={toggleMenu}
                                        />
                                        <NavItem
                                            classes="font-bold text-2xl text-center rounded-md py-2 px-4"
                                            path="/payments"
                                            text="Ιστορικό Πληρωμών"
                                            closeFunction={toggleMenu}
                                        />
                                        <NavItem
                                            classes="font-bold text-2xl text-center rounded-md py-2 px-4"
                                            path="/contact-info"
                                            text="Επικοινωνία - Υποστήριξη"
                                            closeFunction={toggleMenu}
                                        />
                                        <NavItem
                                            classes="font-bold text-2xl text-center rounded-md py-2 px-4"
                                            path="/debts/confirmed"
                                            text="Βεβαιωμένες Οφειλές"
                                            closeFunction={toggleMenu}
                                        />
                                        <NavItem
                                            classes="font-bold text-2xl text-center rounded-md py-2 px-4"
                                            path="/debts/installments"
                                            text="Οφειλές σε Ρύθμιση"
                                            closeFunction={toggleMenu}
                                        />
                                    </>
                                )}

                                <button
                                    className={`font-bold text-2xl ${
                                        isAdmin() ? 'text-white' : ''
                                    }`}
                                    onClick={logout}
                                >
                                    Αποσύνδεση
                                </button>
                            </ul>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    )
}

export default BurgerMenu
